// NPM
import React from 'react';
import PropTypes from 'prop-types';
import { ArrowsCirclesIcon } from '@glu/icons-react/lib';
import { ContainerArrowDownNextIcon } from '@glu/icons-react';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
// Components
import useLocale from 'components/useLocale/useLocale';

import { DATE_TIME_FORMAT } from 'constants.js';
import { JSSClasses } from 'proptypes/jss-prop-types';
import useStyles from './gridHeader.styles';
import GetTrigger from './GetTrigger';

export function GridHeaderComponent({
  generateCSV,
  headerLeftClasses,
  headerLeftContent,
  lastSync,
  printContent,
  // Temp fix while grids are converted
  suppress,
  suppressContentRight,
  sync
}) {
  const locale = useLocale();
  const { gridHeader, left, right, syncText } = useStyles();
  return (
    <div className={headerLeftClasses || gridHeader}>
      <div className={left}>{headerLeftContent}</div>
      {!suppressContentRight && (
        <div className={right}>
          {sync && <ArrowsCirclesIcon onClick={sync} data-qa="arrow-circles-icon" />}
          {lastSync && (
            <div className={syncText} data-qa="last-sync-text">
              {`${locale['header.lastsync']} ${
                moment.isMoment(lastSync) ? lastSync.format(DATE_TIME_FORMAT) : lastSync
              }`}
            </div>
          )}
          {!suppress && (
            <>
              <ContainerArrowDownNextIcon onClick={generateCSV} data-qa="document-arrow-icon" />
              <ReactToPrint
                content={printContent}
                trigger={() => <GetTrigger iconProps={{ 'data-qa': 'printer-icon' }} />}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
}

GridHeaderComponent.defaultProps = {
  headerLeftClasses: null,
  lastSync: '',
  generateCSV() {},
  headerLeftContent: null,
  printContent: () => {},
  suppress: false,
  sync: null,
  suppressContentRight: true
};

GridHeaderComponent.propTypes = {
  headerLeftContent: PropTypes.node,
  headerLeftClasses: JSSClasses,
  lastSync: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  printContent: PropTypes.func,
  generateCSV: PropTypes.func,
  suppress: PropTypes.bool,
  sync: PropTypes.func,
  suppressContentRight: PropTypes.bool
};

export default GridHeaderComponent;
